module.exports = __webpack_public_path__ + "img/cart2.09fb91d3.svg";